module.exports = __webpack_public_path__ + "img/selected1-min.d6ab83f9.png";